import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import { spotName } from '../constants/spot-name';
import template from './btpg-share.component.html';
var BtpgShareComponent = (function () {
    function BtpgShareComponent() {
        this.stepId = '';
        this.stepName = '';
        this.platformLabel = '';
        this.platformName = '';
        this.groupId = '';
        this.guideId = '';
    }
    Object.defineProperty(BtpgShareComponent.prototype, "wtuItemUrl", {
        get: function () {
            return this.getShareUrl();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BtpgShareComponent.prototype, "btpgPdfUrl", {
        get: function () {
            var shareFaqItemUrl = encodeURIComponent(this.getShareUrl());
            var baseUrl = "/support/export/btpg?pdf=1&shareUrl=" + shareFaqItemUrl + "&id=" + this.guideId;
            return baseUrl + "&groupid=" + this.groupId + "&platform=" + this.platformName;
        },
        enumerable: false,
        configurable: true
    });
    BtpgShareComponent.prototype.getShareUrl = function () {
        return window.location.origin + window.location.pathname + '#/' + spotName + '?' +
            "platformLabel" + '=' + this.platformLabel + '&' +
            "stepId" + '=' + this.stepId;
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "stepId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "stepName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "platformLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "platformName", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "groupId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BtpgShareComponent.prototype, "guideId", void 0);
    BtpgShareComponent = __decorate([
        Component({
            selector: 'btpgShare',
            template: template,
        })
    ], BtpgShareComponent);
    return BtpgShareComponent;
}());
export { BtpgShareComponent };
